var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('TableWrapper',{attrs:{"name":"tbl_alarms","mod-count":_vm.modCount,"url":_vm.url,"columns":_vm.columns,"search-form-fields":_vm.formFields,"show-column-visible":true,"offset-height":_vm.offsetHeight,"show-add":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }